import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import loaderReducer from "./loaderSlice";
import snackbarReducer from "./snackBarSlice";
import progressReducer from "./progressStatus"
import commonReducer from "./commonSlice";
import uiConfigReducer from "./uiConfigSlice";

const appStore = configureStore({
	reducer: {
		auth: authReducer,
		loader: loaderReducer,
		snackbar: snackbarReducer,
		progress: progressReducer,
		common: commonReducer,
		uiConfig: uiConfigReducer
	},
});
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof appStore.getState>;
export type AppDispatch = typeof appStore.dispatch;

export default appStore;
